import { BrandfolderHexColors } from '../enums/colors.js';

const defaultTooltip = {
    backgroundColor: '#000',
    textColor: '#FFF'
};
const dangerTooltip = {
    backgroundColor: BrandfolderHexColors.Delete,
    textColor: '#FFF'
};
const primaryTooltip = {
    backgroundColor: '#4462C9',
    textColor: '#FFF'
};

export { dangerTooltip, defaultTooltip, primaryTooltip };
//# sourceMappingURL=tooltip.js.map
